"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNewGuest = exports.getVisitorId = exports.getSessionId = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var firefly_shared_ts_1 = require("firefly-shared-ts");
var browser_1 = require("./browser");
function setVisitorId() {
    var sourceValue = (0, browser_1.getSourceValue)();
    var visitorId = firefly_shared_ts_1.Identity.createVisitorId(sourceValue);
    firefly_utilities_ts_1.FFPersistenceManager.setVisitorId(visitorId, 'cookies');
}
function getSessionId(persistMethod) {
    var sessionHash = firefly_utilities_ts_1.FFPersistenceManager.getSessionValue('sessionHash', persistMethod);
    if ((0, firefly_utilities_helper_ts_1.isNullOrUndefined)(sessionHash)) {
        sessionHash = firefly_shared_ts_1.Identity.createSessionId();
        firefly_utilities_ts_1.FFPersistenceManager.setSessionValue('sessionHash', sessionHash, persistMethod);
    }
    return sessionHash;
}
exports.getSessionId = getSessionId;
function getVisitorId() {
    var visitorId = firefly_utilities_ts_1.FFPersistenceManager.getVisitorId('cookies');
    if (!(0, firefly_utilities_helper_ts_1.isNullOrUndefined)(visitorId)) {
        firefly_utilities_ts_1.FFPersistenceManager.setVisitorId(visitorId, 'cookies');
    }
    return visitorId;
}
exports.getVisitorId = getVisitorId;
function isNewGuest() {
    var newGuest = false;
    if ((0, firefly_utilities_helper_ts_1.isNullOrUndefined)(firefly_utilities_ts_1.FFPersistenceManager.getVisitorId('cookies'))) {
        setVisitorId();
        newGuest = true;
    }
    return newGuest;
}
exports.isNewGuest = isNewGuest;
